import { BSForm } from '@readcloud/component-library';
import React from 'react';

interface SliderInputProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

export function SliderInput({
  label,
  value,
  onChange,
  min = 1,
  max = 20,
  step = 1,
}: SliderInputProps) {
  return (
    <div className="rc-flex rc-flex-col rc-px-2">
      <BSForm.Label>{label}</BSForm.Label>
      <div className="rc-flex rc-flex-row rc-items-center rc-gap-2">
        <BSForm.Range
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          min={min}
          max={max}
          step={step}
        />
        <span className="rc-w-8 rc-text-center">{value}</span>
      </div>
    </div>
  );
}
